import { render, staticRenderFns } from "./AccessoryCta.vue?vue&type=template&id=f96a4f10&"
import script from "./AccessoryCta.vue?vue&type=script&lang=js&"
export * from "./AccessoryCta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f96a4f10')) {
      api.createRecord('f96a4f10', component.options)
    } else {
      api.reload('f96a4f10', component.options)
    }
    module.hot.accept("./AccessoryCta.vue?vue&type=template&id=f96a4f10&", function () {
      api.rerender('f96a4f10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/accessories/AccessoryCta.vue"
export default component.exports